import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import Button from "../components/base/Button";
import FormField from "../components/FormField";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Logo } from "../components/App";
import Icons from "../components/Icons";
import { AuthPage } from "../components/base/AppComponents";
import { passwordSchema } from "../shared/utils/formikValidators";
import { errorMessage } from "../shared/utils/validators";
import "./index.scss";
import MyAccountService from "../services/MyAccountService";
import { Alert, Snackbar } from "@mui/material";
import request from "../shared/http";

document.title = "Orkaaps Accounts";

function SignInPage() {
  const [visible, setVisible] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const domain = window.location.origin;
console.log('domain', domain);
console.log('request', request);
const isDev = window.location.hostname === 'localhost';
const url = '/signin';

  async function handleSubmit(values) {
    setFormSubmitted(true);
    try {
      await axios.post(
        url,
        {
          username: values.userName.trim(),
          password: values.password.trim(),
          type: "user",
        },
        {
          headers: {
            "content-type": "application/x-www-form-urlencoded",
          },
        }
      );
      const account = await MyAccountService.fetch();
      // const organizationId = account.getOrganizationId();
    //   if (!organizationId) {
    //     window.location.replace("/create-store");
    //   }
    //   const stores = await StoreService.getOrganizationStores({
    //     organizationId,
    //   });
    //   if (stores.length === 0) {
    //     window.location.replace("/create-store");
    //   }
      window.location.replace("/");
    } catch (error) {
        console.log('error', error);
        
      const message = errorMessage(error);
      console.log('message', message);
      
      if (message) {
        setSnackbar({
            open: true,
            message: `${message}`,
            severity: "error",
          });
      } else {
        setSnackbar({
            open: true,
            message: 'Something went wrong',
            severity: "error",
          });
      }
    }
  }

  function snackBar() {
    return (
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    )
  }


  const $userName = useRef();
  const formik = useFormik({
    initialValues: {
      userName: "",
      password: "",
    },
    validationSchema: Yup.object().shape({
      userName: Yup.string()
        .trim()
        .required("Required email address")
        .email("Please enter a valid email address"),
      password: passwordSchema,
    }),
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    $userName.current.focus();
  }, []);

  return (
    <AuthPage
      title="Access Your Merchant Account"
      description="Welcome back! Sign in to access your merchant account and manage your business effortlessly."
    >
     <Logo />
      <div className="ui-card__header" style={{ paddingTop: "10px" }}>
        <div className="ui-heading">Sign in</div>
        <div className="ui-subheading" style={{ paddingTop: 10 }}>
          to access Merchant portal
        </div>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <FormField
          ref={$userName}
          type="auth-text"
          name="userName"
          placeholder="johndoe@example.com"
          value={formik.values.userName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            (formSubmitted || formik.submitCount > 0) &&
            formik.touched.userName &&
            formik.errors.userName
          }
        />
        <FormField
          autoComplete="off"
          name="password"
          placeholder="*****"
          value={formik.values.password}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            (formSubmitted || formik.submitCount > 0) &&
            formik.touched.password &&
            formik.errors.password
          }
          type={visible ? "text" : "password"}
          iconSuffix={
            formik.values.password && (
              <div
                style={{ cursor: "pointer" }}
                onClick={() => setVisible(!visible)}
              >
                {visible ? Icons.Visible : Icons.VisibleOff}
              </div>
            )
          }
          maxLength={25}
        />
        <div>
          <a href="/password-reset" className="ui-link">
            Forgot password?
          </a>
          <br />
          <br />
        </div>
        <Button type="submit" appearance="auth-btn">
          Sign in
        </Button>
      </form>
      <p style={{ margin: "auto", paddingTop: 20 }}>
        New to Orkaapps ?
        <a style={{ marginLeft: "5px" }} href="/signup" className="ui-link">
          Get started
        </a>
      </p>
      {snackBar()}
    </AuthPage>
  );
}
export {SignInPage};
